import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enUS from "./locales/en_US";
import ptBR from "./locales/pt_BR";

// Define available languages
export const languages = {
	en_US: { nativeName: "English", flag: "🇺🇸" },
	pt_BR: { nativeName: "Português", flag: "🇧🇷" },
};

export type LanguageKey = keyof typeof languages;

// Initialize i18next
i18n.use(initReactI18next).init({
	resources: {
		en_US: {
			translation: enUS,
		},
		pt_BR: {
			translation: ptBR,
		},
	},
	lng: "en_US", // Default language
	fallbackLng: "en_US",
	interpolation: {
		escapeValue: false, // React already escapes values
	},
});

export default i18n;
